import type { LanguageResource } from "@ruter-as/web-components-and-tools";

interface ConfirmationLanguageResource {
	title: string;
	ticketCreateText: string;
	ticketRequestText: string;
	subscriptionText: string;
}

const confirmationLanguageResource: LanguageResource<ConfirmationLanguageResource> =
	{
		nb: {
			title: "Påmelding fullført",
			ticketCreateText:
				"En SMS med hentekode til bedriftsbilletten er sendt til ditt mobilnummer",
			ticketRequestText:
				"Administratoren har nå fått din forespørsel om bedriftsbillett. Du vil motta en sms med hentekode så fort administrator har godkjent din forespørsel.",
			subscriptionText:
				"Elsykkel: En sms med rabattkode er sendt til ditt mobilnummer. Følg instruksen i meldingen for å fortsette bestillingen av elsykkel.",
		},
	};

export default confirmationLanguageResource;
